module.exports = {
    escapeInput: function(str) {
        if (typeof str == 'string' || str instanceof String)
            return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");

        return str;
    }
};




/** WEBPACK FOOTER **
 ** ./src/app/utils/escape.js
 **/